import { gql } from 'graphql-tag'

export const LOGIN_WITH_TOKEN = gql`
  mutation LoginWithToken($token: String!) {
    loginWithToken(token: $token)
  }
`
